import { Component, OnInit } from '@angular/core';
import { CheckInType, OrderCheckInRequest } from '@app/core/redux/stores';
import { CheckInService } from '@features/ordering/services/checkin.service';

@Component({
  selector: 'app-curbside-space-number',
  templateUrl: './curbside-space-number.component.html',
  styleUrls: ['./curbside-space-number.component.less']
})
export class CurbsideSpaceNumberComponent implements OnInit {
  public isCurbsideSpaceSelected = false;
  public CheckInType = CheckInType;
  selectedCurbsideSpace = 0;
  constructor(public checkIn: CheckInService) { }
  ngOnInit(): void {
    this.checkIn.loading = false;
  }
  setCurbsideSpace() {
    this.isCurbsideSpaceSelected = true;
  }
  cancelCheckIn() {
    this.checkIn.hideModal();
  }
  checkInWithSpace(spaceNumber: string, checkInType: CheckInType) {
    const orderCheckInRequest: OrderCheckInRequest = {
      checkInIndicator : spaceNumber, checkInType : checkInType};
    this.checkIn.checkIn(orderCheckInRequest);
  }
}
